import { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import { getRoutePaths } from '../../utils/i18n';
import { useTranslations } from '../../utils/translations';
import { useLanguage } from '../../utils/LanguageContext';
import './CookieBanner.css';

const STORAGE_KEY = 'twk_cookie_consent';

const CookieBanner = () => {
    const [visible, setVisible] = useState(false);
    const { currentLang } = useLanguage();
    const { t } = useTranslations();
    const paths = getRoutePaths(currentLang);
    const declineRef = useRef(null);

    useEffect(() => {
        const stored = localStorage.getItem(STORAGE_KEY);
        if (!stored) {
            setVisible(true);
        }
    }, []);

    const handleAccept = () => {
        localStorage.setItem(STORAGE_KEY, 'accepted');
        window.twkLoadAnalytics?.();
        setVisible(false);
    };

    const handleDecline = () => {
        localStorage.setItem(STORAGE_KEY, 'declined');
        setVisible(false);
    };

    useEffect(() => {
        if (!visible) return undefined;
        window.requestAnimationFrame(() => {
            declineRef.current?.focus();
        });
        const handleKeyDown = (event) => {
            if (event.key === 'Escape') {
                handleDecline();
            }
        };
        window.addEventListener('keydown', handleKeyDown);
        return () => window.removeEventListener('keydown', handleKeyDown);
    }, [visible]);

    if (!visible) return null;

    return (
        <div className="cookie-banner" role="region" aria-label={t('common', 'cookies.label')}>
            <p className="cookie-banner-eyebrow">{t('common', 'cookies.eyebrow')}</p>
            <p className="cookie-banner-text">
                {t('common', 'cookies.text')}{' '}
                <Link to={paths.privacy} className="cookie-banner-link">{t('common', 'cookies.link')}</Link>.
            </p>
            <div className="cookie-banner-actions">
                <button className="cookie-banner-decline" onClick={handleDecline} ref={declineRef}>
                    {t('common', 'cookies.decline')}
                </button>
                <button className="cookie-banner-accept" onClick={handleAccept}>
                    {t('common', 'cookies.accept')}
                    <span className="arrow-icon">→</span>
                </button>
            </div>
        </div>
    );
};

export default CookieBanner;
